import React, { useContext } from 'react'

import Provider, { EnterpriseInitiativeLoaderContext, EnterpriseInitiativeLoaderContextProvider } from './Provider'

import { IEnterpriseInitiativeLoaderViewProps } from './Interfaces'

import useEnterpriseInitiativeStyles from './Styles'

const EnterpriseInitiativeLoaderPage: React.FC<IEnterpriseInitiativeLoaderViewProps> = ({ children }) => {
  const classes = useEnterpriseInitiativeStyles({})
  const { state } = useContext<EnterpriseInitiativeLoaderContext>(EnterpriseInitiativeLoaderContextProvider)
  return (
    <React.Fragment>
      {children(state.isLoadingEnterpriseInitiativeInfo, state.enterpriseInitiativeInfo, classes.initiativeLandingPage)}
    </React.Fragment>
  )
}

export default React.memo((props: IEnterpriseInitiativeLoaderViewProps) => (
  <Provider enterpriseId={props.enterpriseId} submissionLinkCode={props.submissionLinkCode}>
    <EnterpriseInitiativeLoaderPage {...props} />
  </Provider>
))
